import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import tw from "twin.macro";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ ...props }, ref) => (
  <SwitchPrimitives.Root
    css={[
      tw`inline-flex h-5 w-12 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2  focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-70 data-[state=unchecked]:bg-gray-300 data-[state=checked]:bg-primary-800`,
    ]}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      css={tw`pointer-events-none block h-4 w-7 rounded-full bg-gray-50 shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4`}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
